import { type TimelineEvent } from "@/app/roadmap/roadmap-timeline/roadmap-timeline"

export const roadmapData: TimelineEvent[] = [
    // Phase 1: Ignition & Fair Launch
    {
        year: "Q3 2025",
        title: "Phase 1: Ignition & Fair Launch",
        subtitle: "The Genesis Fart",
        description: [
            {
                text: "Token Creation & Smart Contract Deployment on Solana",
                completed: true,
            },
            { text: "Fair Launch on Pump.fun", completed: true },
            { text: "Website V1 & Social Channels Launch", completed: false },
            {
                text: "Initial Community Building & Guerilla Marketing",
                completed: false,
            },
            {
                text: "Reach Raydium & Initial Liquidity Pool Lock",
                completed: false,
            },
        ],
    },
    // Phase 2: Community & Content Expansion
    {
        year: "Q4 2025",
        title: "Phase 2: Community & Content Expansion",
        subtitle: "Building the Stank",
        description: [
            { text: "CoinGecko & CoinMarketCap Listings", completed: false },
            {
                text: "Launch 'Fart of the Week' Meme Contest Series",
                completed: false,
            },
            {
                text: "Onboard First Wave of Content Creators & Influencers",
                completed: false,
            },
            { text: "Secure Dextools/Dexscreener Trending", completed: false },
            {
                text: "Cross-Community Collaborations with other Meme Projects",
                completed: false,
            },
        ],
    },
    // Phase 3: Utility & Product Development
    {
        year: "Q1 2026",
        title: "Phase 3: Utility & Product Development",
        subtitle: "More Than Just Hot Air",
        description: [
            {
                text: "FartHub NFTs: A collection of gassy digital art",
                completed: false,
            },
            { text: "NFT Staking for $FART rewards", completed: false },
            {
                text: "Launch 'FartHub Swap' - A branded DEX for the community",
                completed: false,
            },
            { text: "First Tier-2 CEX Listings", completed: false },
        ],
    },
    // Phase 4: Ecosystem Growth & Dominance
    {
        year: "Q2 2026+",
        title: "Phase 4: Ecosystem Growth & Global Dominance",
        subtitle: "The Silent But Deadly Killer",
        description: [
            {
                text: "FartHub Mobile App with Integrated Wallet & Swap",
                completed: false,
            },
            {
                text: "Launch Official FartHub Merchandise Line",
                completed: false,
            },
            {
                text: "Strategic Partnerships with Major Brands (Non-crypto)",
                completed: false,
            },
            {
                text: "Tier-1 CEX Listings (Binance, Coinbase)",
                completed: false,
            },
            {
                text: "Host the First Annual 'FartCon' - A Meme Coin Convention",
                completed: false,
            },
        ],
    },
]
